import { Routes } from '@angular/router';
import { EditPorteGreffeComponent } from './edit-porte-greffe/edit-porte-greffe.component';
import { ListesPortesGreffesComponent } from './listes-portes-greffes/listes-portes-greffes.component';

export const PORTES_GREFFES_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const PORTES_GREFFES_ROUTES: Routes = [
    { path: '', component: ListesPortesGreffesComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditPorteGreffeComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditPorteGreffeComponent, data: { roles: ['ORGANISME'] } }
];
